import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_PAYMENT_METHOD_DEF,
} from "./actionTypes"

import {

  getPaymentMethodDefSuccess,
  paymentMethodDefError
  
} from "./actions"

//Include Both Helper File with needed methods
import {
getPaymentMethodDef

} from "../../helpers/backend_helper/backend_helper"

function* get_PaymentMethodDef() {
  try {
    const response = yield call(getPaymentMethodDef)
    yield put(getPaymentMethodDefSuccess(response))
  } catch (error) {
    yield put(paymentMethodDefError(error))
  }
}

function* paymentMethodDefManagementSaga() {

    yield takeEvery(GET_PAYMENT_METHOD_DEF,get_PaymentMethodDef)
}

export default paymentMethodDefManagementSaga
